import { Interest, Filters } from '@io/domain';
import { LoanToValueBodyParamsBuilder } from '@io/builder';

import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import {
    InterestRate,
    InterestProduct,
    MortgageInterestRateParameters,
    MortgageInterestRateResource,
    LoanToValueResponse
} from '@ap/ap-interface-apix-rs-hypotheken-renteoverzicht';

@Injectable({
    providedIn: 'root'
})
export class MortgageInterestRateService {
    readonly mortgageInterestRateResource = inject(MortgageInterestRateResource);

    constructor() {
        this.mortgageInterestRateResource.setApiKey('{<BSPX-RS-HYPOTHEKEN-RENTEOVERZICHT-API-KEY>}');
    }

    getInterestRateOverview(filters: Filters): Observable<Interest[]> {
        const mortgageInterestRateParameters = {
            amortisation_type: filters.amortisationType,
            fixed_rate_period: filters.fixedRatePeriod,
            ltv: filters.loanToValue,
            energy_label: filters.energyLabel
        } as MortgageInterestRateParameters;
        return this.mortgageInterestRateResource
            .getMortgageInterestRate(mortgageInterestRateParameters)
            .pipe(map((interestRate: InterestRate) => this.mapToInterestRates(interestRate)));
    }

    postLoanToValue(mortgage: string, purchasePrice: string): Observable<LoanToValueResponse> {
        return this.mortgageInterestRateResource.postLoanToValue(
            new LoanToValueBodyParamsBuilder().withMortgage(mortgage).withPurchasePrice(purchasePrice).build()
        );
    }

    private mapToInterestRates(interestRate: InterestRate): Interest[] {
        return interestRate.interest_products
            ? interestRate.interest_products.map((interestProduct: InterestProduct) => this.mapToInterest(interestProduct))
            : [];
    }

    private mapToInterest(interestProduct: InterestProduct): Interest {
        return {
            name: interestProduct.name,
            interestRate: interestProduct.interest
        } as Interest;
    }
}
